import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Pill = ({ icon, label }) => {
  const Icon = Icons[icon] || Icons.Zap;
  return (
    <div className="group mx-2 flex shrink-0 items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.035] py-2 pl-2 pr-5 backdrop-blur-sm transition-colors hover:border-brand/40 hover:bg-white/[0.06]">
      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand/10 text-brand ring-1 ring-brand/20 shadow-[0_0_16px_rgba(23,253,253,0.28)] transition-transform duration-300 group-hover:scale-110">
        <Icon className="h-4 w-4" />
      </span>
      <span className="whitespace-nowrap text-sm font-medium text-white/80">{label}</span>
    </div>
  );
};

export const CapabilityStrip = () => {
  const { t } = useTranslation();
  const caps = t('capabilities', { returnObjects: true });
  const row = [...caps, ...caps];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative border-y border-white/10 bg-[#001826]/40 py-5"
    >
      <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_7%,black_93%,transparent)]">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {row.map((c, i) => <Pill key={i} {...c} />)}
        </div>
      </div>
    </motion.div>
  );
};
